<div class="search-container">
    <input 
        type="text" 
        [placeholder]="placeholder"
        [formControl]="searchField"
        [ngStyle]="{'max-width': maxWidth, 'font-size': placeholderFontSize}"
  />
  </div>